import React from 'react'
import { DownloadOutlined } from '@ant-design/icons'

interface Props {
    onSelectCompany: () => void
    onSelectGroup: () => void
}

const PdfSelectionContent: React.FC<Props> = ({ onSelectCompany, onSelectGroup }) => (
    <div style={{ padding: '8px 0 16px' }}>
        <p style={{ textAlign: 'center', fontSize: '14px', color: '#888', marginBottom: '24px' }}>
            Choose which invoice PDF you want to view
        </p>
        <div style={{ display: 'flex', gap: '20px' }}>
            <div
                onClick={onSelectCompany}
                style={{
                    flex: 1,
                    border: '2px solid #1890ff',
                    borderRadius: '10px',
                    padding: '28px 16px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    background: '#f0f7ff',
                    transition: 'box-shadow 0.2s',
                }}
            >
                <DownloadOutlined style={{ fontSize: '30px', color: '#1890ff', marginBottom: '10px', display: 'block' }} />
                <p style={{ fontWeight: 700, fontSize: '15px', margin: '0 0 6px', color: '#1890ff' }}>Company PDF</p>
                <p style={{ fontSize: '12px', color: '#999', margin: 0 }}>View the company invoice</p>
            </div>
            <div
                onClick={onSelectGroup}
                style={{
                    flex: 1,
                    border: '2px solid #52c41a',
                    borderRadius: '10px',
                    padding: '28px 16px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    background: '#f6ffed',
                    transition: 'box-shadow 0.2s',
                }}
            >
                <DownloadOutlined style={{ fontSize: '30px', color: '#52c41a', marginBottom: '10px', display: 'block' }} />
                <p style={{ fontWeight: 700, fontSize: '15px', margin: '0 0 6px', color: '#52c41a' }}>Group PDF</p>
                <p style={{ fontSize: '12px', color: '#999', margin: 0 }}>View the group invoice</p>
            </div>
        </div>
    </div>
)

export default PdfSelectionContent
